"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownSummary = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const shared_1 = require("../../shared");
const Styled = styled_components_1.default.div `
	height: 100%;
	max-height: ${(p) => p.theme.navHeight}px;
	position: relative;
	display: flex;
	align-items: center;
	transition: 0.2s background ${(p) => p.theme.easing};
	background: ${(p) => (p.accentColor ? p.theme.palette.accent.background : "transparent")};
	color: ${(p) => (p.accentColor ? p.theme.palette.accent.backgroundText : p.theme.palette.text.primary)};

	&:focus {
		outline-color: ${(p) => p.theme.palette.text.primary};
		outline-offset: -2px;
		outline-width: 1px;
	}

	.friendly-triangle {
		position: absolute;
		bottom: -40px;
		left: -20px;
		width: 60px;
		height: 60px;
		background: transparent;
		z-index: 2;
		transform: rotate(55deg);

		&.right {
			left: initial;
			right: -20px;
			transform: rotate(-55deg);
		}
	}
`;
const DropdownSummary = ({ children, openMenu, summaryRef, onKeyUp, menuId, disableIndicator, accentColor, disableTriangles, }) => {
    const { open: myMenuOpen, otherOpen: otherMenuOpen } = (0, shared_1.useOtherActiveMenu)(menuId);
    const { setMobileMenuOpen } = (0, shared_1.useMobileMenu)();
    const onClick = (0, react_1.useCallback)((e) => {
        setMobileMenuOpen(false);
        if (openMenu && typeof openMenu === "function") {
            openMenu(e);
        }
    }, [setMobileMenuOpen, openMenu]);
    let kids = children;
    if (react_1.default.isValidElement(children)) {
        kids = react_1.default.cloneElement(children, Object.assign({}, {
            myMenuOpen,
            otherMenuOpen,
            disableIndicator,
        }));
    }
    return (react_1.default.createElement(Styled, { ref: summaryRef, tabIndex: 0, className: "menu-summary", onClick: onClick, onKeyUp: (0, shared_1.useHandleKeyUp)(onKeyUp, onKeyUp), onMouseDown: epic_games_nav_shared_1.stopFocusOnClick, accentColor: accentColor },
        !disableTriangles && myMenuOpen && react_1.default.createElement("div", { className: "friendly-triangle left" }),
        kids,
        !disableTriangles && myMenuOpen && react_1.default.createElement("div", { className: "friendly-triangle right" })));
};
exports.DropdownSummary = DropdownSummary;
//# sourceMappingURL=DropdownSummary.js.map